import store from '../redux/store'
import { setTreeData,  setTreeBuildData,  setNodesData,} from '../redux/actions'
import throttle from 'lodash/throttle';


// const DB_API_HOST = 'http://127.0.0.1:8000';
const DB_API_HOST = 'https://fitted-deploy-back-end.herokuapp.com';

const API_PATH = DB_API_HOST + '/api'

const REGISTER_PATH = DB_API_HOST + '/api/v1/dj-rest-auth/registration/'
const LOGIN_PATH = DB_API_HOST + '/api/v1/dj-rest-auth/login/'
const LOGOUT_PATH = DB_API_HOST + '/api/v1/dj-rest-auth/logout/'
const LOAD_USER_PATH = DB_API_HOST + '/api/v1/dj-rest-auth/user/'
const CHECK_TOKEN_PATH = DB_API_HOST + '/api/v1/dj-rest-auth/token/verify/'

const OPTIONS_DATA_PATH = DB_API_HOST + '/options'
const OPTION_META_DATA_PATH = DB_API_HOST + '/getMeta'

const JOKE_PATH = DB_API_HOST + '/joke'

const EXTANDED_SCORES_PATH = API_PATH + '/scores'
const SCORE_BY_NODE_PATH = DB_API_HOST +  '/api/scores'
/* Tree Context Paths */

const TREE_CONTEXT_DETAIL_PATH = API_PATH + '/tree_context/'
const TREE_CONTEXT_LIST_PATH = API_PATH +'/tree_context/'
const UPLOAD_TREE_CONTEXT_PATH =  API_PATH + '/tree_context/upload'

const randomAmazonUrl = "https://ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=fitted07-20&marketplace=amazon&amp;region=US&placement=B0775MV9K2&asins=B0775MV9K2&linkId=5f1a0627c199b122daf2d37dcd5ca650&show_border=false&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff"

export const checkUrlAmazonConection = async () => {
  try{
    const amazonResponse = await fetch(randomAmazonUrl, {
      headers: ({
        'Access-Control-Allow-Origin': 'ws-na.amazon-adsystem.com'
      })
    })
    console.log("amazon response");
    console.log(amazonResponse.status);
    return amazonResponse.status === 200;
  }
  catch(e){
    console.log("error in amazon url");
    console.log(e);
    return false;
  }

}

export const getCsrfToken = async () => {
  /* todo loading csrf token at every request -> can be made butter*/
  let _csrfToken = null;
  if (_csrfToken === null) {
    const response = await fetch(`${DB_API_HOST}/csrf/`, {
      credentials: 'include',
    });
    const data = await response.json();
    _csrfToken = data.csrfToken;
  }
  return _csrfToken;
}

export const getPossibleOptions = async (path) => {
  console.log('sending path:');
  console.log(path);
  const value_array = path.map((step) => {
    return step.value
  })
  let api_path = value_array.join("_")
  console.log("api path");
  console.log(api_path);
  const response = await fetch(`${DB_API_HOST}/api/options?path=${api_path}`);
  const options = await response.json();

  return [...options.options,
    {
      label: "הוסף מידע חדש",
      value: "new",
      type: "new"
    }
  ]
}


export const getPossibleDataValues = async (path) => {
  console.log('getting possibole data values:');
  console.log(path);
  const value_array = path.map((step) => {
    return step.value
  })
  let api_path = value_array.join("_")
  console.log("api path");
  console.log(api_path);
  const prop = "value_options"
  const response = await fetch(`${DB_API_HOST}/api/options?path=${api_path}&prop=${prop}`);
  const options = await response.json();
  console.log("got results");
  console.log(options);
  return [...options.options]
}





export const getTreeData = async (tree_id) => {
  const token = store.getState().auth.key;
  console.log("token");
  console.log(token);
  console.log(`getting tree data for tree id: ${tree_id}`);
  const response = await fetch(`${DB_API_HOST}/logic_tree/${tree_id}`, {
    method: 'GET',
    ...tokenConfig()

  });
  const data = await response.json();
  console.log("got data tree from db");
  console.log(data.root_node);
  return {
    ...data
  };
}

export const uploadFeedback = async (user, content) => {
  let data_upload = {user: user, content: content}
  let json_build = JSON.stringify(data_upload)
  const response = await fetch(`${DB_API_HOST}/feedback`, {
    method: 'POST',
    headers: ({
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json',
    }),
    body: json_build
  });
  const data = await response;
  return data;
}

export const uploadTreeData = async (number, title, description, treeBuildData, nodesData) => {
  let data_upload = {
    title: title,
    description: description,
    logic_tree_build: treeBuildData,
    nodes_data: nodesData
  }
  let json_build = JSON.stringify(data_upload)
  const token = store.getState().auth.key;
  const response = await fetch(`${DB_API_HOST}/uploadTree`, {
    method: 'POST',
    headers: ({
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }),
    credentials: 'include',
    body: json_build
  });
  const data = await response;
  console.log(data);
  return data;
}

export const recalculateTreeScore = async (tree_id) => {
  const response = await fetch(`${DB_API_HOST}/api/logic_tree?id=${tree_id}&action=reload_score`, {
    method: 'GET'
  });
  const data = await response.json();
  return data;
}

export const logInUser = async (username, email, password) => {
  console.log({
    username,
    email,
    password
  });
  const body = JSON.stringify({
    username,
    email,
    password
  });
  console.log(body);
  const config = {
    method: 'POST',
    headers: {
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: body
  };
  // Request Body
  const logInResponse = await fetch(LOGIN_PATH, config)
  console.log(logInResponse);
  if (logInResponse.status == 400) {
    throw 'Unable to log in with provided credentials.';
  }
  if (logInResponse.status == 200) {
    const logInData = await logInResponse.json()
    return logInData;
  }
}

export const registerUserDb = async (username, email, password1, password2) => {
  // Request Body
  const body = JSON.stringify({
    username,
    email,
    password1,
    password2
  });

  const config = {
    method: 'POST',
    headers: {
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: body
  };
  const registerResponse = await fetch(REGISTER_PATH,
    config);
  if (registerResponse.status == 400) {
    const errorData = await registerResponse.json();
    throw errorData;
  }
  if (registerResponse.status == 201) {
    const registerData = await registerResponse.json();
    return registerData
  }
}

export const logoutUserDb = async (key) => {
  console.log("logoutUserDb was called");
  const body = JSON.stringify({
    key
  })
  const requestConfig = {
    method: 'POST',
    headers: {
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: body
  };
  /* todo add user auth */
  const logoutResponse = await fetch(LOGOUT_PATH,
    requestConfig);
  const logoutData = await logoutResponse.json()
  console.log("logout data");
  console.log(logoutData);
  return logoutData;
}


export const loadUserFromDb = async (token) => {
  const requestConfig = {
    method: 'GET',
    headers: {
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    credentials: 'include',
  };
  /* todo add user auth */
  const checkTokenResponse = await fetch(LOAD_USER_PATH,
    requestConfig);
  const checkTokenData = await checkTokenResponse.json()
  console.log("load user response");
  console.log(checkTokenData);
  return checkTokenData;
}

// Setup config with token - helper function
const tokenConfig = () => {
  // Get token from state
  const token = store.getState().auth.key;

  // Headers
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // If token, add to headers config
  if (token) {
    config.headers['Authorization'] = `Token ${token}`;
  }

  return config;
};



export const dbGetLogicTreesAlbum = async () => {
  const token = store.getState().auth.key;
  console.log("token");
  console.log(token);
  console.log(`getting users trees`);
  const response = await fetch(`${DB_API_HOST}/user_trees/`, {
    method: 'GET',
    ...tokenConfig()

  });
  const data = await response.json();
  console.log(data);
  return data;
}

export const saveTreeData = async (number,
  title, description,
  treeBuildData, nodesData) => {
  let data_upload = {
    title: title,
    description: description,
    logic_tree_build: treeBuildData,
    nodes_data: nodesData
  }
  console.log(data_upload);
  let json_build = JSON.stringify(data_upload)
  const token = store.getState().auth.key;
  const response = await fetch(`${DB_API_HOST}/logic_tree/${number}`, {
    method: 'PATCH',
    headers: ({
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }),
    credentials: 'include',
    body: json_build
  });
  const data = await response;
  console.log(data);
  return data;
}


export const getScoresByNode = async (nodesData, nodeId) => {
  console.log("getting node score");
  let config = {
    method: 'POST',
    headers: ({
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json',
    }),
  }
  let query = "?";
  if (nodesData) {
    config.body = JSON.stringify({"nodesData":nodesData})
  }
  let url =  SCORE_BY_NODE_PATH + `/${nodeId}?category=phones&treeId=1`
  const response = await fetch(url, config);
  const data = await response;
  const dataJson = await data.json()
  console.log(dataJson);
  return dataJson;
}




export const dbGetOptionMetaData = async (category) => {
  console.log("getting option metaData");
  let query = ""
  if (category) {
    query = `?category=${category}`;
  } else {
    const storeParam = store.getState().optionQueryParams;
    if (storeParam) {
      Object.entries(storeParam).map(([key, value]) => {
        if (key === "category") {
          query = `?category=${value}`;
        }
      })
    }
  }
  const optionMetaDataResponse =  await fetch(`${OPTION_META_DATA_PATH}${query}`)
  const optionMetaDataData = await optionMetaDataResponse.json()
  console.log(optionMetaDataData);
  return optionMetaDataData;
}



export const getOptions = async (queryData, prop, nodesData, givenUrl) => {
  console.log(`getting options ${queryData}, ${nodesData}`);
  let config = {
    method: 'POST',
    headers: ({
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json',
    }),
  }

  let query = "?expanded=true&";
  const storeParam = store.getState().optionQueryParams;
  console.log("store param");
  console.log(storeParam);
  console.log(nodesData);
  let noNodesData;
  if (nodesData) {
    config.body = JSON.stringify({"nodesData":nodesData})
    noNodesData = false;
  } else {
    noNodesData = true;
  }
  if (!storeParam.ordering) {
    storeParam.ordering = "-score"
  }
  if (storeParam) {
    Object.entries(storeParam).map(([key, value]) => {
      if (key === "treeId" && noNodesData) {
        return;
      }
      query = query + key + "=" + value + "&"
    })
  }
  if (queryData) {
    Object.entries(queryData).map(([key, value]) => {
      query = query + key + "=" + value + "&"
    })
  }

  console.log(`query:${query}`);
  console.log(config.body);
  let url = DB_API_HOST + '/options' + query + "&context=1 &prop=" + prop
  if (givenUrl) { // TODO: bad code. if given url no need to comput query
    url = givenUrl;
  }
  const response = await fetch(url, config);
  const data = await response;
  const dataJson = await data.json()
  console.log(dataJson);
  return dataJson;
}


const throttleTime = 1000;

export const throttledGetOptionshAPI = throttle(async (queryData, nodesData, givenUrl) => {
            return await getOptions(queryData, nodesData, givenUrl)},
            throttleTime, {
            leading: true
            }
);

export const getExtendedScores = async (optionsId, nodesData) => {
  console.log('getting extended scores');
  console.log(optionsId);
  console.log(nodesData);
  let config = {
    method: 'POST',
    headers: ({
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json',
    }),
  }
  let noNodesData;
  if (nodesData) {
    const body = {"nodesData":nodesData, "options":optionsId}
    config.body = JSON.stringify(body)
    noNodesData = false;
  } else {
    noNodesData = true;
  }
  let query = "?";
  const storeParam = store.getState().optionQueryParams;
  if (storeParam) {
    Object.entries(storeParam).map(([key, value]) => {
      if (key === "treeId" && noNodesData) {
        return;
      }
      query = query + key + "=" + value + "&"
    })
  }
  console.log(`query:${query}`);
  console.log(config.body);
  const response = await fetch(`${EXTANDED_SCORES_PATH}${query}`, config);
  console.log("got extended scores");
  const data = await response;
  const dataJson = await data.json();
  console.log(dataJson);
  return dataJson;
}

export const dbGetItemDataById = async (itemId, category) => {
  // check if we already have option:
  const optionsData = store.getState().options.optionsChosen;
  const len = optionsData.length;
  console.log(`getting data for item  ${itemId}`);
  // got here, then we dont have option. need to get from db.
  console.log(`${OPTIONS_DATA_PATH}/${itemId}?category${category}`);
 const response = await fetch(`${OPTIONS_DATA_PATH}/${itemId}?category=${category}`);
 const data = await response;
 const dataJson = await data.json();
 return dataJson;
}

export const getJoke = async (category) => {
  console.log(`getting random joke from: ${category}`);
  const response = await fetch(`${JOKE_PATH}?category=${category}`);
  const data = await response.json();
  console.log("got joke from db");
  console.log(data.content);
  return {
    ...data
  };
}

/* Tree Context Methods */
export const getUserTreeContexts = async () => {
  console.log("starting process: get user tree contexts from db");

  /* get users token */
  const token = store.getState().auth.key;
  const response = await fetch(TREE_CONTEXT_LIST_PATH, {
    method: 'GET',
    ...tokenConfig()

  });
  const data = await response.json();
  console.log("finished process: get user tree contexts from db");
  return data;
}

export const getTreeContext = async (contextId) => {
  /* get users token */
  const token = store.getState().auth.key;
  const response = await fetch(`https://fitted-deploy-back-end.herokuapp.com/api/tree_context/${contextId}`);
  const data = await response.json();
  return data;
}

export const dbUploadTreeContext = async (treeContext) => {
  console.log("uploading context");
  console.log(treeContext);
  let json_build = JSON.stringify(treeContext)
  const token = store.getState().auth.key;
  const response = await fetch(UPLOAD_TREE_CONTEXT_PATH, {
    method: 'POST',
    headers: ({
      'X-CSRFToken': await getCsrfToken(),
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }),
    credentials: 'include',
    body: json_build
  });
  const uploadContextResponse = await response;
  if (uploadContextResponse.status == 400 ||
    uploadContextResponse.status == 403 ||
    uploadContextResponse.status == 500) {
    throw 'Unable to upload context';
  }
  if (uploadContextResponse.status == 200 ||
    uploadContextResponse.status == 201) {
    const dataJson = await uploadContextResponse.json();
    return dataJson;
  }
}

export const getUserDefualtTreeContext = async (treeId) => {
  const users_tree_context = await getUserTreeContexts()
  console.log("users trees contexts");
  console.log(users_tree_context);
  if (users_tree_context.length > 0) {
    const filtered = users_tree_context.filter(context => context.tree == treeId);
    if (filtered.length > 0) {
      return users_tree_context[0];
    }
  } else {
    return null;
  }
}
